import React, { useState } from 'react';
import {
  Container, Typography, Grid, Card, CardContent, CardMedia,
  Button, Box, Tabs, Tab, Alert, AlertTitle,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import SendIcon from '@mui/icons-material/Send';
import { useNavigate } from 'react-router-dom';

const products = {
  laptops: [
    { id: 'lap-1', name: 'MacBook Pro M2',    price: 1999, display: '$1,999', description: 'Latest MacBook Pro with M2 chip, perfect for professionals',           image: '/images/products/macbook-pro.jpg' },
    { id: 'lap-2', name: 'Gaming Powerhouse', price: 1799, display: '$1,799', description: 'Ultimate gaming laptop with RTX 4080, 32GB RAM',                       image: '/images/products/gaming-laptop.jpg' },
    { id: 'lap-3', name: 'Ultrabook Pro',     price: 1299, display: '$1,299', description: 'Ultra-thin and light laptop for business users',                        image: '/images/products/ultrabook.jpg' },
    { id: 'lap-4', name: 'Student Chromebook',price:  399, display: '$399',   description: 'Affordable and reliable laptop for students',                           image: '/images/products/chromebook.jpg' },
    { id: 'lap-5', name: 'Business Laptop',   price:  999, display: '$999',   description: 'High-performance laptop for business professionals',                    image: '/images/products/business-laptop.jpg' },
    { id: 'lap-6', name: 'Creator Laptop',    price: 1499, display: '$1,499', description: 'Powerful laptop for content creators and designers',                    image: '/images/products/student-laptop.jpg' },
  ],
  desktops: [
    { id: 'dsk-1', name: 'Gaming Beast PC',          price: 2999, display: '$2,999', description: 'Ultimate gaming PC with RTX 4090 and i9 processor',              image: '/images/products/gaming-desktop.jpg' },
    { id: 'dsk-2', name: 'Professional Workstation', price: 2499, display: '$2,499', description: 'High-end workstation for professional tasks',                    image: '/images/products/workstation.jpg' },
    { id: 'dsk-3', name: 'Mini PC Pro',              price:  799, display: '$799',   description: 'Compact yet powerful mini PC for any desk',                      image: '/images/products/mini-pc.jpg' },
    { id: 'dsk-4', name: 'All-in-One PC',            price: 1299, display: '$1,299', description: 'Sleek all-in-one PC with 27" 4K display',                        image: '/images/products/all-in-one.jpg' },
    { id: 'dsk-5', name: 'Custom RGB PC',            price: 1999, display: '$1,999', description: 'Custom-built PC with stunning RGB lighting',                     image: '/images/products/custom-pc.jpg' },
    { id: 'dsk-6', name: 'Office Desktop',           price:  899, display: '$899',   description: 'Reliable desktop PC for office work',                            image: '/images/products/office-desktop.jpg' },
  ],
  mobile: [
    { id: 'mob-1', name: 'iPhone 15 Pro',    price: 1099, display: '$1,099', description: 'Latest iPhone with pro camera system',                                  image: '/images/products/iphone-pro.jpg' },
    { id: 'mob-2', name: 'Android Flagship', price:  999, display: '$999',   description: 'Premium Android phone with top specs',                                  image: '/images/products/android-flagship.jpg' },
    { id: 'mob-3', name: 'iPad Pro',         price:  799, display: '$799',   description: 'Powerful tablet for work and creativity',                               image: '/images/products/ipad-pro.jpg' },
    { id: 'mob-4', name: 'Pro Tablet',       price:  649, display: '$649',   description: 'Versatile Android tablet for productivity',                             image: '/images/products/tablet.jpg' },
    { id: 'mob-5', name: 'Basic Smartphone', price:  299, display: '$299',   description: 'Reliable smartphone for essential needs',                               image: '/images/products/basic-phone.jpg' },
    { id: 'mob-6', name: '5G Smartphone',    price:  599, display: '$599',   description: 'Fast 5G smartphone with great camera',                                  image: '/images/products/smartphone.jpg' },
  ],
  accessories: [
    { id: 'acc-1', name: 'Pro Gaming Mouse',      price:  79, display: '$79',  description: 'High-precision gaming mouse with RGB lighting',                       image: '/images/products/gaming-mouse.jpg' },
    { id: 'acc-2', name: 'Mechanical Keyboard',   price: 129, display: '$129', description: 'Premium mechanical keyboard with RGB backlight',                      image: '/images/products/mechanical-keyboard.jpg' },
    { id: 'acc-3', name: 'Gaming Headset',        price:  99, display: '$99',  description: 'Immersive gaming headset with 7.1 surround sound',                    image: '/images/products/gaming-headset.jpg' },
    { id: 'acc-4', name: '4K Webcam Pro',         price: 129, display: '$129', description: 'Crystal clear 4K webcam for streaming and meetings',                  image: '/images/products/webcam.jpg' },
    { id: 'acc-5', name: '1TB External SSD',      price: 149, display: '$149', description: 'Fast and portable external storage solution',                         image: '/images/products/1TB External SSD.jpg' },
    { id: 'acc-6', name: 'Gaming Chair',          price: 299, display: '$299', description: 'Ergonomic gaming chair with lumbar support',                          image: '/images/products/gaming-chair.jpg' },
    { id: 'acc-7', name: 'Wireless Charging Pad', price:  49, display: '$49',  description: '15W fast wireless charger for all devices',                           image: '/images/products/wireless-charger.jpg' },
    { id: 'acc-8', name: 'USB-C Hub',             price:  59, display: '$59',  description: '7-in-1 USB-C hub with HDMI and card reader',                          image: '/images/products/usb-hub.jpg' },
    { id: 'acc-9', name: 'Premium Laptop Bag',    price:  89, display: '$89',  description: 'Stylish and protective laptop bag with many pockets',                  image: '/images/products/laptop-bag.jpg' },
  ],
};

const categories = ['laptops', 'desktops', 'mobile', 'accessories'];
const categoryMap = { laptops: 'Laptop', desktops: 'Desktop', mobile: 'Phone', accessories: 'Accessory' };

const Products = () => {
  const [tabValue, setTabValue] = useState(0);
  const navigate = useNavigate();

  const handleRequestProduct = (product) => {
    navigate('/product-request', {
      state: { category: categoryMap[categories[tabValue]], model: product.name },
    });
  };

  const cardStyle = {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    background: 'linear-gradient(135deg, rgba(255,107,107,0.1) 0%, rgba(255,217,61,0.2) 100%)',
    backdropFilter: 'blur(10px)',
    borderRadius: '15px',
    boxShadow: '0 4px 30px rgba(0,0,0,0.1)',
    border: '1px solid rgba(255,255,255,0.3)',
    transition: 'all 0.3s ease-in-out',
    '&:hover': { transform: 'translateY(-5px)', boxShadow: '0 8px 25px rgba(0,0,0,0.1)' },
  };

  return (
    <Box sx={{ bgcolor: 'background.default', py: 8 }}>
      <Container>
        <Typography variant="h2" align="center" gutterBottom className="gradient-text" sx={{ mb: 4 }}>
          Our Products
        </Typography>

        <Alert
          severity="info"
          icon={<InfoOutlinedIcon />}
          sx={{
            mb: 5,
            borderRadius: '12px',
            background: 'rgba(41, 128, 185, 0.12)',
            border: '1px solid rgba(41, 128, 185, 0.35)',
            '& .MuiAlert-icon': { color: '#2980b9' },
          }}
        >
          <AlertTitle sx={{ fontWeight: 700 }}>For Presentation Purposes Only</AlertTitle>
          The products displayed on this page are shown for reference and inspiration only — they are
          not currently available in our inventory for direct purchase. To get a product that matches
          your needs, click <strong>"Request This Product"</strong> on any item and fill out our
          short requirements form. Our team will source it and get back to you with availability
          and pricing.
        </Alert>

        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 4 }}>
          <Tabs
            value={tabValue}
            onChange={(_, v) => setTabValue(v)}
            centered
            variant="scrollable"
            scrollButtons="auto"
            sx={{ '& .MuiTab-root': { color: 'text.secondary', '&.Mui-selected': { color: 'primary.main' } } }}
          >
            {categories.map((cat) => (
              <Tab key={cat} label={cat.charAt(0).toUpperCase() + cat.slice(1)} sx={{ textTransform: 'capitalize' }} />
            ))}
          </Tabs>
        </Box>

        <Grid container spacing={4}>
          {products[categories[tabValue]].map((product) => (
            <Grid item xs={12} sm={6} md={4} key={product.id}>
              <Card className="glass-effect" sx={cardStyle}>
                <CardMedia
                  component="img"
                  height="200"
                  image={product.image}
                  alt={product.name}
                  sx={{ objectFit: 'cover' }}
                />
                <CardContent sx={{ flexGrow: 1, p: 3, display: 'flex', flexDirection: 'column' }}>
                  <Typography variant="h5" gutterBottom className="gradient-text">{product.name}</Typography>
                  <Typography variant="h6" color="primary" gutterBottom>{product.display}</Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2, flexGrow: 1 }}>
                    {product.description}
                  </Typography>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 'auto' }}>
                    <Button
                      variant="contained"
                      startIcon={<SendIcon />}
                      onClick={() => handleRequestProduct(product)}
                      sx={{
                        background: 'linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%)',
                        color: 'background.default',
                        '&:hover': { background: 'linear-gradient(135deg, var(--primary) 20%, var(--secondary) 80%)' },
                      }}
                    >
                      Request a Product
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

      </Container>
    </Box>
  );
};

export default Products;
